const pageBody = document.querySelector('body.password');
const modalOpen = document.querySelector('.password-modal .modal__toggle');
const modalClose = document.querySelector('.password-modal .modal__close-button');
const modalBody = document.querySelector('.password-modal .modal__content');

modalOpen.addEventListener('click', openModal);
modalOpen.addEventListener('keydown', function(event) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    openModal();
  }
});

modalClose.addEventListener('click', closeModal);
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeModal();
  }
});

function openModal() {
  pageBody.classList.add('overflow-hidden');
  modalBody.classList.add('active');
  modalBody.setAttribute('aria-hidden', 'false');
  modalOpen.setAttribute('aria-expanded', 'true');
}
function closeModal() {
  pageBody.classList.remove('overflow-hidden');
  modalBody.classList.remove('active');
  modalBody.setAttribute('aria-hidden', 'true');
  modalOpen.setAttribute('aria-expanded', 'false');
}